<template>
  <div class="modal-page">
    <h3>Модальное окно</h3>
    <div class="rows">
      <Loader v-if="loader" />
      <div class="row version-row">
        Номер версии: {{ version }}
      </div>
      <div class="row">
        <Ui :data="{type: 'editor', value: content, label: 'Содержимое модального окна'}" @set="setContent($event)" />
      </div>
      <div class="row activity-row">
        <Ui :data="{type: 'toggler', value: activity, label: 'Активность'}" @set="setActivity($event)" />
      </div>
      <div class="row">
        <Ui :data="{type: 'text', value: cookieTtl, label: 'Время жизни cookie (в часах)'}" @set="setCookieTtl($event)" />
      </div>
      <div class="buttons">
        <Button label="Сохранить" @click="saveFunction" />
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Ui from '@/components/Ui'
import Button from '@/components/ui/Button'
import Loader from '@/components/Loader'

export default {
  components: {
    Ui,
    Button,
    Loader
  },
  computed: {
    ...mapState('modalpage', [
      'loader', 'version', 'content', 'activity', 'cookieTtl'
    ]),
    ...mapGetters('modalpage', [])
  },
  methods: {
    ...mapActions('modalpage', ['loadFunction', 'saveFunction']),
    ...mapMutations('modalpage', ['setContent', 'setActivity', 'setCookieTtl', 'setVersion'])
  },
  mounted () {
    this.loadFunction()
  }
}
</script>

<style lang="scss" scoped>
.modal-page{
  @include box(100%, 100%, relative, null, null, null, null, null, null);
  h3 { margin: 10px 0 10px 20px; }
  .rows{
    @include box(100%, auto, relative, null, null, null, null, null, null);
    @include flex(left, top, column);
    flex-wrap: wrap;
    @include padding(0, 0, 0, 0);
    .row{
      @include box(50%, auto, relative, null, null, null, null, null, null);
      padding: 0 0 0 20px;
    }
    .activity-row {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .version-row {
      padding-top: 0px;
      padding-bottom: 10px;
    }
    .remove{
      @include text(0.9vw, 400, 0.05vw, null, left, $modalText);
      span{
        @include text(null, 500, null, null, null, null);
      }
    }
    .buttons{
      @include box(100%, auto, relative, null, null, null, null, null, null);
      @include flex(right, top, row);
      justify-content: flex-start;
      @include padding(0, 2vw, 0, 0);
      padding: 1vw 0 0 20px;
      .button{
        @include size(10vw, null)
      }
    }
  }
}
</style>